import React from "react"
import { IncludeExcludeFilter } from "./include_exclude_filter"

const t = (key: string) => window.i18n.t(key)

interface CompanyTypeFilterProps {
  includedValues: string[]
  excludedValues: string[]
  companyTypes: Array<{ value: string; label: string }>
  onChangeIncluded: (values: string[]) => void
  onChangeExcluded: (values: string[]) => void
}

export function CompanyTypeFilter({
  includedValues,
  excludedValues,
  companyTypes,
  onChangeIncluded,
  onChangeExcluded,
}: CompanyTypeFilterProps) {
  // Convert to the format expected by IncludeExcludeFilter
  const allowedValues = companyTypes.map((type) => ({
    id: type.value,
    name: type.label,
  }))

  return (
    <IncludeExcludeFilter
      label={t("js.back.discover.filters.company_type.title")}
      icon="sitemap"
      placeholder={t("js.back.discover.filters.company_type.placeholder")}
      tooltip={t("js.back.discover.filters.company_type.tooltip")}
      includedValues={includedValues}
      excludedValues={excludedValues}
      allowedValues={allowedValues}
      onChangeIncluded={onChangeIncluded}
      onChangeExcluded={onChangeExcluded}
    />
  )
}
